import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { PlantListFacade } from './plant-list.facade';

@Injectable({
  providedIn: 'root',
})
export class PlantListGuard {
  constructor(private plantListFacade: PlantListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.plantListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.plantListFacade);
  }
}
